export function getAuthorityList() {
    return [
        { name: "超级管理员", id: '1' },
        { name: "管理员1", id: '2' },
        { name: "管理员2", id: '3' },
        { name: "管理员3", id: '4' },
        { name: "管理员4", id: '5' },
        { name: "管理员5", id: '6' },
    ]
}

export function getModelList() {
    return [
        { name: "数据概况", id: "1", authority: "1" },
        { name: "审核操作", id: "2", authority: "1" },
        { name: "信息表单", id: "5", authority: "1" },
        { name: "权限管理", id: "3", authority: "1" },
        { name: "设置", id: "4", authority: "1" },
    ]
}

/**
 * 将数据库中拿到的数据进行界面值的转换
 * @param {*} modelList 
 */
export function changeModelToValue(modelList) {
    modelList.forEach(element => {
        element.authority = (element.authority == "1" || element.authority == 1) ? true : false
    });
    return modelList
}

/**
 * 将界面权限数据转化成数据库数据
 * @param {*} modelList 
 */
export function changeValueToModel(modelList) {
    modelList.forEach(element => {
        element.authority = element.authority ? "1" : "2"
    });
    return modelList
}

export function getUserList() {
    return [
        { id: "1", name: "张三", account: "123456", role: "普通管理员" },
    ]
}